import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { SUBSCRIBE_TYPE, UNSUBSCRIBE_TYPE } from "../actionTypes.js";
export function createSubscription(endpoint, _ref) {
  var args = _ref.args;
  return {
    type: SUBSCRIBE_TYPE,
    endpoint: endpoint,
    meta: {
      args: args,
      key: endpoint.key.apply(endpoint, _toConsumableArray(args)),
      fetch: function fetch() {
        return endpoint.apply(void 0, _toConsumableArray(args));
      },
      schema: endpoint.schema,
      options: endpoint
    }
  };
}
/** Future action shape
{
  type: SUBSCRIBE_TYPE,
  endpoint,
  meta: {
    args,
  },
} */

export function createUnsubscription(endpoint, _ref2) {
  var args = _ref2.args;
  return {
    type: UNSUBSCRIBE_TYPE,
    endpoint: endpoint,
    meta: {
      args: args,
      key: endpoint.key.apply(endpoint, _toConsumableArray(args)),
      options: endpoint
    }
  };
}
/** Future action shape
{
  type: UNSUBSCRIBE_TYPE,
  endpoint,
  meta: {
    args,
  },
} */